<template>
  <div class="card subscription-options-card">
    <div class="header-control">
      <h2>Подписка на экосистему решений WAY2WEI</h2>
      <div class="control-button">
        <a-button :class="{'secondary-button': showOptions || isMobile, 'primary-button': !showOptions && !isMobile}" @click="showOptions = !showOptions">
          <template v-if="!isMobile">
            <span>
              {{ showOptions ? 'Свернуть' : 'Развернуть'}}
            </span>
          </template>
          <template v-if="isMobile" #icon>
            <DownOutlined v-if="showOptions" />
            <UpOutlined v-else />
          </template>
        </a-button>
      </div>
    </div>
    <p>
      Подписка связывает диагностику и обучение в единый процесс. Используйте полный арсенал инструментов платформы для более глубокой и качественной работы с кадрами.
    </p>
    <div v-if="showOptions" class="control-block">
      <div class="segment-wrapper">
        <a-segmented v-model:value="currentType" :options="typeFilterOptions" />
      </div>
      <div
          ref="scroller"
          class="options-cards"
          @mousedown="onMouseDown"
          @mousemove="onMouseMove"
          @mouseup="onMouseUp"
          @mouseleave="onMouseUp"
          @dragstart.prevent
      >
        <div v-for="(card, idx) in options" :key="idx" class="option-card">
          <div class="desc-block">
            <p class="option-title">{{ card.title }}</p>
            <p class="grey-text">{{card.desc}}</p>
          </div>
          <div v-for="product in card.tests" :key="product.name" class="passing">
            <p>
              {{ product.name }}
            </p>
            <div class="product-quantity">
              {{ product.quantity }} / {{ product.unit }}
            </div>
          </div>

          <a-divider style="margin: 12px 0" />

          <div v-for="product in card.courses" :key="product.name" class="passing" :class="{'grey-text': !product.quantity}">
            <p>
              {{ product.name }}
            </p>
            <div class="product-quantity" v-if="product.quantity">
              {{ product.quantity }} / {{ product.unit }}
            </div>
            <div v-else>
              <LockFilled />
            </div>
          </div>

          <a-divider style="margin: 12px 0" />

          <div v-for="product in card.specialProducts" :key="product.name" class="passing" :class="{'grey-text': !product.enabled}">
            <p>
              {{ product.name }}
            </p>
            <div class="product-quantity" v-if="product.enabled">
              <CheckCircleFilled style="color: var(--main-green)" />
            </div>
            <div v-else>
              <LockFilled />
            </div>
          </div>

          <a-divider style="margin: 12px 0" />

          <div v-for="product in card.specialProfiles" :key="product.name" class="passing" :class="{'grey-text': !product.enabled}">
            <p>
              {{ product.name }}
            </p>
            <div class="product-quantity" v-if="product.enabled">
              <CheckCircleFilled style="color: var(--main-green)" />
            </div>
            <div v-else>
              <LockFilled />
            </div>
          </div>

          <a-divider style="margin: 12px 0" />

          <div class="price">
            <p>Стоимость / {{filterTranslateMap[currentType]}} </p>
            <div class="price-block">
              {{ card.price[currentType] }} &#8381;
            </div>
          </div>

          <div class="option-card-button">
            <a-button class="primary-button" @click="showOrderForm">
              Выбрать
            </a-button>
          </div>
        </div>
      </div>
      <div class="button-more">
        <a-button v-if="currentSubscriptionSummary && currentSubscriptionSummary.length" class="secondary-button" @click="showSubscription">
          К подписке
        </a-button>
        <a-button class="secondary-button">
          Подробнее о тарифах
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {ref} from "@vue/runtime-core";
  import {DownOutlined, UpOutlined, LockOutlined, LockFilled, CheckCircleFilled} from "@ant-design/icons-vue";
  import {computed} from "@vue/reactivity";
  import {useStore} from "vuex";
  import useBreakpoints from "@/mixins/useBreakpoints";

  export default {
    components: {DownOutlined, UpOutlined, LockOutlined, LockFilled, CheckCircleFilled},
    emits: ['showSubscription', 'showOrderForm'],
    setup(props, context) {
      const showOptions = ref(true);
      const store = useStore();
      const currentSubscriptionSummary = computed(() => store.state.subscription.subscriptionSummary);

      const typeFilterOptions = [
        {
          label: 'На квартал',
          value: 'quartal'
        },
        {
          label: 'На полгода',
          value: 'half_year'
        },
        {
          label: 'На год',
          value: 'year'
        }
      ];

      const filterTranslateMap = {
        quartal: 'Квартал',
        half_year: 'Полгода',
        year: 'Год',
      }

      const currentType = ref('quartal');

      const { isMobile } = useBreakpoints()

      const scroller = ref(null);

      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;

      function onMouseDown(e) {
        if (e.button !== 0) return;

        isDragging = true;
        startX = e.clientX;
        startScrollLeft = scroller.value.scrollLeft;

        e.preventDefault();
      }

      function onMouseMove(e) {
        if (!isDragging) return;

        const dx = e.clientX - startX;
        scroller.value.scrollLeft = startScrollLeft - dx;

        e.preventDefault();
      }

      function onMouseUp() {
        isDragging = false;
      }

      const options = [
        {
          "title": "Подбор и лидерство",
          "desc": "Для быстрой и объективной оценки кандидатов при подборе и принятии кадровых решений.",
          "tests": [
            { "name": "Стандартный отчет", "quantity": 8, "unit": "кв" },
            { "name": "Управленческий потенциал", "quantity": 2, "unit": "кв" }
          ],
          "courses": [{ "name": "Тренажеры", "quantity": 0, "unit": "кв" }],
          "specialProducts": [
            { "name": "Бенчмаркинг", "enabled": true },
            { "name": "База знаний по ЭИ (+ AI помощник)", "enabled": false },
            { "name": "Мини-практикум «Клиентский сервис»", "enabled": false },
            { "name": "Ежедневные инструменты", "enabled": false }
          ],
          "specialProfiles": [
            { "name": "Сессии с HR-экспертом", "quantity": 0, "unit": "кв", "enabled": false },
            { "name": "Эталонный профиль", "quantity": 0, "unit": "кв", "enabled": false },
            { "name": "ЭИ-ландшафт команды", "quantity": 0, "unit": "кв", "enabled": false }
          ],
          "price": { "quartal": 12000, "half_year": 30000, "year": 90000, "currency": "RUB" }
        },
        {
          "title": "Оценка и развитие",
          "desc": "Для оценки эмоционального интеллекта сотрудников и их системного развития.",
          "tests": [
            { "name": "Стандартный отчет", "quantity": 25, "unit": "кв" },
            { "name": "Управленческий потенциал", "quantity": 5, "unit": "кв" }
          ],
          "courses": [{ "name": "Тренажеры", "quantity": 20, "unit": "кв" }],
          "specialProducts": [
            { "name": "Бенчмаркинг", "enabled": true },
            { "name": "База знаний по ЭИ (+ AI помощник)", "enabled": true },
            { "name": "Мини-практикум «Клиентский сервис»", "enabled": true },
            { "name": "Ежедневные инструменты", "enabled": false }
          ],
          "specialProfiles": [
            { "name": "Сессии с HR-экспертом", "quantity": 1, "unit": "кв", "enabled": true },
            { "name": "Эталонный профиль", "quantity": 0, "unit": "кв", "enabled": false },
            { "name": "ЭИ-ландшафт команды", "quantity": 0, "unit": "кв", "enabled": false }
          ],
          "price": { "quartal": 20000, "half_year": 50000, "year": 150000, "currency": "RUB" }
        },
        {
          "title": "Стратегия и аналитика",
          "desc": "Для глубокой аналитики команд, развития лидерства и стратегических HR-решений.",
          "tests": [
            { "name": "Стандартный отчет", "quantity": 80, "unit": "кв" },
            { "name": "Управленческий потенциал", "quantity": 20, "unit": "кв" }
          ],
          "courses": [{ "name": "Тренажеры", "quantity": 20, "unit": "кв" }],
          "specialProducts": [
            { "name": "Бенчмаркинг", "enabled": true },
            { "name": "База знаний по ЭИ (+ AI помощник)", "enabled": true },
            { "name": "Мини-практикум «Клиентский сервис»", "enabled": true },
            { "name": "Ежедневные инструменты", "enabled": true }
          ],
          "specialProfiles": [
            { "name": "Сессии с HR-экспертом", "quantity": 2, "unit": "кв", "enabled": true },
            { "name": "Эталонный профиль", "quantity": 1, "unit": "кв", "enabled": true },
            { "name": "ЭИ-ландшафт команды", "quantity": 1, "unit": "кв", "enabled": true }
          ],
          "price": { "quartal": 20000, "half_year": 50000, "year": 150000, "currency": "RUB" }
        }
      ];

      const showSubscription = () => {
        context.emit('showSubscription');
      }

      const showOrderForm = () => {
        context.emit('showOrderForm');
      }

      return {
        currentType,
        isMobile,
        showOptions,
        scroller,
        options,
        onMouseUp,
        onMouseDown,
        onMouseMove,
        typeFilterOptions,
        filterTranslateMap,
        showSubscription,
        currentSubscriptionSummary,
        showOrderForm
      }
    }
  }
</script>

<style scoped lang="scss">
  h2 {
    font-weight: 600;
    font-size: 20px;
    line-height: 120%;
    margin-bottom: 0;
  }

  .header-control {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 16px;
    margin-bottom: 8px;
  }

  .control-block {
    font-size: 14px;
  }

  .options-cards{
    margin-bottom: 16px;
    width: 100%;
    max-width: 100%;
    display: grid;
    grid-auto-flow: column;
    gap: 16px;
    overflow-x: auto;
    overflow-y: hidden;

    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    cursor: grab;
    touch-action: pan-x;
    user-select: none;
  }

  .options-cards::-webkit-scrollbar{ display:none; }
  .options-cards:active{ cursor: grabbing; }

  .option-card {
    min-width: 349px;
    min-height: 535px;
    padding: 20px;
    border: 1px solid var(--main-green);
    border-radius: 8px;
  }

  .segment-wrapper {
    margin: 16px 0;
  }

  .button-more {
    display: flex;
    gap: 8px;

    @media (max-width: $mobile-breakpoint) {
      flex-direction: column;
    }
  }

  .button-more .secondary-button {
    @media(max-width: $mobile-breakpoint) {
      width: 100%;
    }
  }

  p {
    margin: 0;
  }

  .option-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .option-card .grey-text {
    font-size: 14px;
  }

  .desc-block {
    height: 85px;
    margin-bottom: 16px;
  }

  .passing {
    display: flex;
    justify-content: space-between;
    column-gap: 10px;
    margin-bottom: 5px;
  }

  .product-quantity {
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
  }

  .price-block {
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;
    color: var(--main-green);
  }

  .option-card-button {
    margin-top: 16px;
  }

  .option-card-button .primary-button {
    width: 100%;
  }

  .option-card .price {
    display: flex;
    justify-content: space-between;
    column-gap: 10px;
    align-items: center;
  }

  .subscription-options-card {
    min-height: fit-content;
  }

  :deep(.anticon-lock) {
    color: rgba(0, 0, 0, 0.15);
  }
</style>
